/* loaded by smart-asset */
export default require("./assets/yellow-tote.i.svg")